import { Location } from 'history';
import { useLocation as useRouterLocation } from 'react-router-dom';
// @ts-ignore upgrade @types/react
import { useSyncExternalStore } from 'use-sync-external-store/shim';

import { history } from 'src/providers';
import { LocationState } from 'src/types/routes.types';

export const useLocation = () => useRouterLocation<LocationState>();

export const useLocationSelector = <T>(
  selector: (location: Location<LocationState>) => T,
): T => {
  return useSyncExternalStore(
    history.listen,
    () => selector(history.location),
  );
};
